import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=6457eca4&"
import script from "./AddressItem.controller.js?vue&type=script&lang=js&"
export * from "./AddressItem.controller.js?vue&type=script&lang=js&"
import style0 from "./AddressItem.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports